module.exports = __webpack_public_path__ + "static/media/crossraodsCard.1e2de880.jpg";